import { BasicsBaseApiV2 } from "../BasicsBaseApiV2";

export class ReportTemplateApi extends BasicsBaseApiV2 {

    public get ControllerName(): any {
        return 'reportTemplate';
    }

}